import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';

import { Flex } from '@olist/united';

export const Container = styled(Flex)`
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.h3`
  color: ${themeGet('olist.color.neutral.stronger')};
  font-size: ${themeGet('olist.fontSize.2xlarge')};
  margin-bottom: 10px;
  white-space: nowrap;
`;

export const Subtitle = styled.div`
  color: ${themeGet('olist.color.neutral.base')};
  font-size: ${themeGet('olist.fontSize.1xsmall')};
  margin-bottom: 36px;

  > * {
    margin: 0;
    text-align: center;
  }
`;
